import React, { useState } from 'react';
import { ActivateStoreIcon, EarnRewardsIcon, InstallExtensionIcon, NormalShopIcon } from '../icons';

const STEPS = [
    {
        cls: 's2',
        title: 'Activate',
        sub: 'Pick any item below',
        icon: <ActivateStoreIcon />,
    },
    {
        cls: 's3',
        title: 'Shop as Normal',
        sub: 'Buy whatever you usually do',
        icon: <NormalShopIcon />,
    },
    {
        cls: 's4',
        title: 'Earn Rewards',
        sub: 'Auto-credited to wallet',
        icon: <EarnRewardsIcon/>,
    },
];

const HowToBanner = () => {
    const [expanded, setExpanded] = useState(true);

    return (
        <div className="how-it-works">
            <button
                type="button"
                className="how-toggle"
                onClick={() => setExpanded(prev => !prev)}
                aria-expanded={expanded}
            >
                <span className="how-label">How it works</span>
                <svg
                    className={`how-chevron${expanded ? ' how-chevron--open' : ''}`}
                    width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            {expanded && (
                <div className="how-steps">
                    {STEPS.map((step, i) => (
                        <React.Fragment key={i}>
                            <div className="how-step">
                                <div className={`step-icon ${step.cls}`}>{step.icon}</div>
                                <div>
                                    <div className="step-title">{step.title}</div>
                                    <div className="step-sub">{step.sub}</div>
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HowToBanner;